import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import WhatsAppButton from "../../components/whatsAppButton/WhatsAppButton";
import MobileMenu from "../../components/menuMobile/MenuMobile";
import Menu from "../../components/menuDesktop/MenuDesktop";
import { getBalance } from "../../redux/actions/session";
import "./ChatApp.scss";

import { firebase, firestore } from "../../utils/firebase";
import { useCollectionData } from "react-firebase-hooks/firestore";

import avatar1 from "../../assets/images/avatar/avatar1.webp";
import avatar2 from "../../assets/images/avatar/avatar2.webp";
import avatar3 from "../../assets/images/avatar/avatar3.webp";
import avatar4 from "../../assets/images/avatar/avatar4.webp";
import avatar5 from "../../assets/images/avatar/avatar5.webp";
import avatar6 from "../../assets/images/avatar/avatar6.webp";
import avatar7 from "../../assets/images/avatar/avatar7.webp";
import avatar8 from "../../assets/images/avatar/avatar8.webp";
import avatar9 from "../../assets/images/avatar/avatar9.webp";
import avatar10 from "../../assets/images/avatar/avatar10.webp";
import avatar11 from "../../assets/images/avatar/avatar11.webp";
import avatar12 from "../../assets/images/avatar/avatar12.webp";
import avatar13 from "../../assets/images/avatar/avatar13.webp";
import avatar14 from "../../assets/images/avatar/avatar14.webp";
import avatar15 from "../../assets/images/avatar/avatar15.webp";
import avatar16 from "../../assets/images/avatar/avatar16.webp";
import avatar17 from "../../assets/images/avatar/avatar17.webp";
import avatar18 from "../../assets/images/avatar/avatar18.webp";
import avatar19 from "../../assets/images/avatar/avatar19.webp";
import avatar20 from "../../assets/images/avatar/avatar20.webp";
import avatar21 from "../../assets/images/avatar/avatar21.webp";
import avatar22 from "../../assets/images/avatar/avatar22.webp";
import avatar23 from "../../assets/images/avatar/avatar23.webp";
import avatar24 from "../../assets/images/avatar/avatar24.webp";

const getAvatar = (author) => {
  const authorName = author?.nickname || author || "Test";

  const index = authorName
    .split("")
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);

  const rest = index % 24;
  if (rest === 0) return avatar1;
  if (rest === 1) return avatar2;
  if (rest === 2) return avatar3;
  if (rest === 3) return avatar4;
  if (rest === 4) return avatar5;
  if (rest === 5) return avatar6;
  if (rest === 6) return avatar7;
  if (rest === 7) return avatar8;
  if (rest === 8) return avatar9;
  if (rest === 9) return avatar10;
  if (rest === 10) return avatar11;
  if (rest === 11) return avatar12;
  if (rest === 12) return avatar13;
  if (rest === 13) return avatar14;
  if (rest === 14) return avatar15;
  if (rest === 15) return avatar16;
  if (rest === 16) return avatar17;
  if (rest === 17) return avatar18;
  if (rest === 18) return avatar19;
  if (rest === 19) return avatar20;
  if (rest === 20) return avatar21;
  if (rest === 21) return avatar22;
  if (rest === 22) return avatar23;
  if (rest === 23) return avatar24;
};

function formatTimestamp(timestamp) {
  const date = timestamp?.toDate();
  const hours = date?.getHours();
  const minutes = date?.getMinutes()?.toString()?.padStart(2, "0");
  return `${hours}:${minutes}`;
}

// firebase and firestore imported from utils/firebase

function ChatApp() {
  const dispatch = useDispatch();
  const shouldFetch = useRef(true);
  const nickname = useSelector((state) => state?.session?.nickname);
  const token = useSelector((state) => state.session.token);

  useEffect(() => {
    if (shouldFetch.current) {
      shouldFetch.current = false;

      if (token) {
        dispatch(getBalance());
      }
    }
  });

  return (
    <>
      <Menu />
      <div className="chat-container">
        <div className="chat-app">
          <section>
            <ChatRoom nickname={nickname} />
          </section>
        </div>
        <MobileMenu />
      </div>
    </>
  );
}

function ChatRoom({ nickname }) {
  const dummy = useRef();
  const messagesRef = firestore.collection("messages");
  const query = messagesRef.orderBy("createdAt", "desc").limit(20);

  const [messages] = useCollectionData(query, { idField: "id" });

  const [formValue, setFormValue] = useState("");

  const sendMessage = async (e) => {
    e.preventDefault();

    await messagesRef.add({
      text: formValue,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      author: nickname,
    });

    setFormValue("");
    dummy?.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    dummy?.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <>
      <main>
        {messages &&
          messages
            .slice(0)
            .reverse()
            .map((msg, index) => <ChatMessage key={index} message={msg} />)}

        <span ref={dummy}></span>
      </main>

      <form onSubmit={sendMessage}>
        <input
          value={formValue}
          onChange={(e) => setFormValue(e.target.value)}
          placeholder="Digite sua mensagem..."
        />

        <button type="submit" disabled={!formValue}>
          Enviar
        </button>
      </form>
    </>
  );
}

function ChatMessage(props) {
  const { text, author, createdAt } = props.message;

  const messageClass = "sent";
  const formattedTime = formatTimestamp(createdAt);

  return (
    <>
      <div
        className={`message ${messageClass}`}
        style={{
          display: "flex",
          alignItems: "flex-start",
          margin: "10px",
          background: "#2d2e30",
        }}
      >
        <img
          style={{ marginRight: "12px" }}
          src={getAvatar(author)}
          alt="profile"
        />
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>
              <b>{author?.nickname || author || "Anônimo"}</b>
            </p>
            <p style={{ fontSize: "0.8rem", color: "#a0a0a0" }}>
              {formattedTime}
            </p>
          </div>
          <p>{text}</p>
        </div>
      </div>
    </>
  );
}

export default ChatApp;
